import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type { TypeGetShippingLabelsParams, TypeGetShippingLabelsResponse } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 리스트 조회 API
 */
export const fetchShippingLabels = async (
  params: TypeGetShippingLabelsParams
): Promise<TypeGetShippingLabelsResponse> => {
  const { data } = await axiosInstance.get<TypeGetShippingLabelsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABELS,
    { params }
  );
  return data;
};

type UseGetShippingLabelsQueryOptions = {
  params: TypeGetShippingLabelsParams;
  enabled?: boolean;
};

/**
 * [운송장 관리] 운송장 리스트 조회 Query Hook
 */
export const useGetShippingLabelsQuery = ({ params, enabled = true }: UseGetShippingLabelsQueryOptions) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.shippingLabels(params),
    queryFn: () => fetchShippingLabels(params),
    enabled,
    staleTime: 0,
    gcTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
};
